import React from 'react';
import { _translate as t } from "../../services/core";
import PropTypes from 'prop-types';

/**
 * Translate Components helper
 *
 * @param {Object} props
 */
var Translate = function Translate(_ref) {
  var id = _ref.id;
  if (!id) {
    return null;
  }
  return /*#__PURE__*/React.createElement("span", {
    className: "textTranslation"
  }, t(id));
};
Translate.propTypes = {
  id: PropTypes.string.isRequired
};
export default Translate;